module.exports = __webpack_public_path__ + "static/img/143.0da118f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/143.png
// module id = TAtZ
// module chunks = 0